import { motion } from "framer-motion";

export const ProductOverview = () => {
  return (
    <section 
      id="product"
      className="py-24 md:py-32 bg-[#050505] border-y border-white/10"
      data-testid="product-overview-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="max-w-3xl">
          {/* Section label */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="font-mono text-sm tracking-[0.3em] text-[#E82D00] mb-6"
          >
            PRODUCT OVERVIEW
          </motion.p>

          {/* Heading */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white mb-8"
            style={{ fontFamily: 'Oswald, sans-serif' }}
            data-testid="overview-heading"
          >
            Every Athlete<br />
            <span className="text-[#A3A3A3]">Uses Creatine</span>
          </motion.h2>

          {/* Body text */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="space-y-6"
          >
            <p className="text-lg md:text-xl text-[#A3A3A3] leading-relaxed" data-testid="overview-text-1">
              Creatine is naturally present in muscle tissue and is rapidly depleted during high-intensity training.
            </p>
            <p className="text-lg md:text-xl text-[#E5E5E5] leading-relaxed" data-testid="overview-text-2">
              Supplementation restores phosphocreatine stores, supporting repeated explosive effort, strength output, and overall training capacity.
            </p>
          </motion.div>

          {/* Accent line */}
          <motion.div
            initial={{ width: 0 }}
            whileInView={{ width: 80 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="h-1 bg-[#E82D00] mt-12"
          />
        </div>
      </div>
    </section>
  );
};

export default ProductOverview;
